import { FileText, ShoppingCart, Receipt, TestTube2, ClipboardList, Tag, Sparkles, Package, FileCheck2, Wrench, Newspaper, Printer } from "lucide-react";

// Central config: one line per subtype = colour + icon + label. Referenced by
// list rows, board cards, and ticket detail header.
export const TASK_TYPE_META = {
  quotation:         { label: "Quotation",         icon: FileText,      tone: "bg-blue-50 text-blue-700 border-blue-200" },
  purchase_order:    { label: "Purchase Order",    icon: ShoppingCart,  tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  invoice:           { label: "Invoice",           icon: Receipt,       tone: "bg-amber-50 text-amber-700 border-amber-200" },
  testing:           { label: "Testing",           icon: TestTube2,     tone: "bg-purple-50 text-purple-700 border-purple-200" },
  proposal:          { label: "Proposal",          icon: ClipboardList, tone: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  clean_office:      { label: "Clean office",      icon: Sparkles,      tone: "bg-teal-50 text-teal-700 border-teal-200" },
  delivery_packet:   { label: "Delivery",          icon: Package,       tone: "bg-orange-50 text-orange-700 border-orange-200" },
  submit_tender:     { label: "Submit tender",     icon: FileCheck2,    tone: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  install_equipment: { label: "Install IT equip.", icon: Wrench,        tone: "bg-rose-50 text-rose-700 border-rose-200" },
  brochure:          { label: "Brochure",          icon: Newspaper,     tone: "bg-pink-50 text-pink-700 border-pink-200" },
  printing:          { label: "Printing",          icon: Printer,       tone: "bg-lime-50 text-lime-700 border-lime-200" },
  other:             { label: "Internal task",     icon: Tag,           tone: "bg-slate-100 text-slate-700 border-slate-300" },
};

export const TASK_TYPE_OPTIONS = Object.keys(TASK_TYPE_META);

export default function TaskTypeBadge({ type, size = "md" }) {
  const meta = TASK_TYPE_META[type];
  if (!meta) return null;
  const Icon = meta.icon;
  const sz = size === "sm"
    ? "text-[9px] px-1.5 py-0.5 gap-1 [--i:9px]"
    : "text-[10px] px-2 py-0.5 gap-1.5 [--i:11px]";
  return (
    <span
      data-testid={`task-type-badge-${type}`}
      className={`inline-flex items-center border rounded-sm font-mono uppercase tracking-[0.15em] ${meta.tone} ${sz}`}
      title={meta.label}
    >
      <Icon className="h-[var(--i)] w-[var(--i)]" strokeWidth={1.75} />
      {meta.label}
    </span>
  );
}
